'use strict';

var EmblaCarousel = require('embla-carousel');
var shopTheLookDataLayer = require('./shopTheLookDataLayer');

var activeInstances = [];

var FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';

function removeGalleryCtas() {
    $('.shop-the-look-gallery-cta').remove();
}

function updateGalleryCtaTabStops($carousel) {
    var $slides = $carousel.find('.slick-slide');
    if (!$slides.length) return;

    $slides.each(function () {
        var isActive = $(this).hasClass('slick-active');
        $(this).find('.shop-the-look-gallery-cta').attr('tabindex', isActive ? '0' : '-1');
    });
}

function addGalleryCtas($wrapper) {
    var label = $('.shop-the-look-cta-label').text().trim();
    var brand = $('.product-detail').attr('data-shop-the-look-brand');
    var hasShopTheLook = $wrapper.find('.shop-the-look').length > 0;

    removeGalleryCtas();
    if (!label || !brand || !hasShopTheLook) return;

    $('.product-detail .pdp-primary-images .pdp-main-carousel .carousel-item:not(.pdp-video)').each(function () {
        var slide = this;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'shop-the-look-gallery-cta';
        button.textContent = label;
        button.setAttribute('aria-label', label);

        button.addEventListener('keydown', function (event) {
            event.stopPropagation();
        });
        button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            $(slide).trigger('zoom.destroy');
            slide.classList.remove('zoomDesk');
            var target = document.querySelector('.shop-the-look');
            if (!target) return;

            var header = document.querySelector('header');
            var headerHeight = header ? header.getBoundingClientRect().height : 0;
            var targetOffset = target.getBoundingClientRect().top + window.pageYOffset;
            var targetTop = targetOffset - headerHeight;
            var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            window.scrollTo({ top: targetTop, behavior: reduceMotion ? 'auto' : 'smooth' });

            var heading = target.querySelector('.recommendation-title');
            if (heading) {
                heading.setAttribute('tabindex', '-1');
                heading.focus({ preventScroll: true });
            }
        });

        slide.appendChild(button);
    });

    var $carousel = $('.product-detail .pdp-primary-images .pdp-main-carousel');
    updateGalleryCtaTabStops($carousel);
    $carousel.off('afterChange.shopTheLookGalleryCta').on('afterChange.shopTheLookGalleryCta', function () {
        updateGalleryCtaTabStops($carousel);
    });
}

/**
 * Roving tabindex: only the active slide should be reachable via Tab.
 * Elements in other slides get tabindex="-1"; their original tabindex
 * (if any) is restored once their slide becomes active again.
 *
 * Deliberately keyed off selectedScrollSnap() rather than slidesInView():
 * on desktop each slide is only 85% wide (shopTheLook.scss) so the next
 * slide always peeks in partially — Embla already counts that sliver as
 * "in view" at its default threshold, which made that peeking slide's
 * content tabbable too. Focusing a partially-visible element then made
 * the browser auto-scroll to reveal it, hijacking Tab before it could
 * ever reach the Next button. The active snap is the only slide that's
 * actually meant to be interactive.
 * @param {Object} emblaApi - The Embla Carousel API instance
 * @param {Array} slides - The carousel's slide nodes
 */
function updateSlideFocusability(emblaApi, slides) {
    var selectedIdx = emblaApi.selectedScrollSnap();
    slides.forEach(function (slideNode, index) {
        var isVisible = index === selectedIdx;
        $(slideNode).find(FOCUSABLE_SELECTOR).each(function () {
            var $el = $(this);
            var hasStoredOriginal = $el.data('stlOrigTabindex') !== undefined;

            if (isVisible) {
                if (hasStoredOriginal) {
                    var original = $el.data('stlOrigTabindex');
                    if (original === '') {
                        $el.removeAttr('tabindex');
                    } else {
                        $el.attr('tabindex', original);
                    }
                    $el.removeData('stlOrigTabindex');
                }
            } else if (!hasStoredOriginal) {
                $el.data('stlOrigTabindex', $el.attr('tabindex') || '');
                $el.attr('tabindex', '-1');
            }
        });
    });
}

/**
 * Moves focus to the first tabbable element of the slide currently in view,
 * mirroring the same after-navigation focus behavior used by the site's
 * Slick carousels (see thirdParty/slickSlider.js).
 * @param {Object} emblaApi - The Embla Carousel API instance
 * @param {Array} slides - The carousel's slide nodes
 */
function focusFirstVisibleSlideElement(emblaApi, slides) {
    setTimeout(function () {
        var activeSlide = slides[emblaApi.selectedScrollSnap()];
        if (!activeSlide) return;

        var $focusable = $(activeSlide).find(FOCUSABLE_SELECTOR).filter(function () {
            return $(this).attr('tabindex') !== '-1';
        }).first();

        if ($focusable.length) {
            $focusable[0].focus();
        }
    }, 150);
}

/**
 * Initializes Embla Carousel for Shop the Look
 * @param {boolean} fromUpdate - if true, skip the initial AJAX fetch (content already set by caller)
 */
function initCarousel(fromUpdate) {
    var $wrapper = $('.shop-the-look-wrapper');
    // If not loaded yet, fetch it via AJAX — but only on initial call, not after updateShopTheLook
    if (!fromUpdate && $wrapper.length > 0 && $wrapper.find('.shop-the-look').length === 0) {
        var url = $wrapper.data('stl-url');
        if (url) {
            // eslint-disable-next-line no-use-before-define
            updateShopTheLook(url);
            return;
        }
    }

    // Clean up old instances if reinit
    if (activeInstances.length > 0) {
        activeInstances.forEach(function (instance) {
            instance.destroy();
        });
        activeInstances = [];
    }

    var $shopTheLook = $('.shop-the-look');
    if (!$shopTheLook.length) return;

    shopTheLookDataLayer.observeCarouselVisibility($shopTheLook[0]);

    var mainCarouselNode = document.querySelector('.shop-the-look__carousel.embla');
    if (mainCarouselNode) {
        // Desktop config
        var mainOptions = {
            loop: true,
            align: 'start',
            containScroll: 'trimSnaps',
            // Embla's default focus-driven auto-scroll fights the browser's own
            // Tab order (it re-snaps the track on every focusin), which is why the
            // Next/Prev buttons became unreachable by keyboard. Nav is button-driven
            // here, same as the site's other carousels, so we don't need it.
            watchFocus: false
        };
        // eslint-disable-next-line new-cap
        var mainEmbla = EmblaCarousel.default ? EmblaCarousel.default(mainCarouselNode, mainOptions) : EmblaCarousel(mainCarouselNode, mainOptions);
        activeInstances.push(mainEmbla);

        var slides = mainEmbla.slideNodes();
        // Only the active slide should be reachable via Tab — the rest are
        // reached by pressing Next/Prev, not by tabbing past them.
        updateSlideFocusability(mainEmbla, slides);

        // Pre/Next buttons
        var prevBtn = document.querySelector('.shop-the-look__prev');
        var nextBtn = document.querySelector('.shop-the-look__next');

        if (prevBtn && nextBtn) {
            prevBtn.addEventListener('click', function () {
                mainEmbla.scrollPrev();
                focusFirstVisibleSlideElement(mainEmbla, slides);
            }, false);
            nextBtn.addEventListener('click', function () {
                mainEmbla.scrollNext();
                focusFirstVisibleSlideElement(mainEmbla, slides);
            }, false);
        }

        // Initialize Shop the Look carousel analytics
        var $carousel = $(mainCarouselNode);

        if ($carousel.length > 0) {
            shopTheLookDataLayer.observeCarouselVisibility(mainEmbla);

            $('body').on('click', '.shop-the-look__carousel .shop-the-look__product-tile', function () {
                var $tile = $(this);
                var anchorItemId = $('.product-detail').data('pid') || '';
                var $container = $tile.closest('.embla__container');
                var position = $container.find('.shop-the-look__product-tile').index($tile) + 1;
                var productId = $tile.data('product-id') || '';
                var lookId = $tile.data('look-id') || 'look_1';

                shopTheLookDataLayer.pushStlCarouselClickedEvent(
                    position,
                    productId,
                    lookId,
                    anchorItemId,
                    window.location.href
                );
            });
        }

        // Click overflow to advance
        slides.forEach(function (slideNode, index) {
            var heroNode = slideNode.querySelector('.shop-the-look__hero');
            if (heroNode) {
                heroNode.addEventListener('click', function () {
                    // if it's not the fully visible slide, scroll to it
                    if (!mainEmbla.slidesInView().includes(index)) {
                        mainEmbla.scrollTo(index);
                    }
                });
            }
        });

        mainEmbla.on('select', function () {
            // Update active styling on hero image
            var selectedIdx = mainEmbla.selectedScrollSnap();
            slides.forEach(function (s, i) {
                var hero = s.querySelector('.shop-the-look__hero');
                if (hero) {
                    if (i === selectedIdx) {
                        hero.classList.add('is-active');
                    } else {
                        hero.classList.remove('is-active');
                    }
                }
            });

            updateSlideFocusability(mainEmbla, slides);
        });
    }

    $('body').off('click.stlProductTile').on('click.stlProductTile', '.shop-the-look .shop-the-look__product-tile', function () {
        var $tile = $(this);
        var anchorItemId = $('.product-detail').data('pid');
        if (anchorItemId === $('#masterProductIDValue').val()) {
            anchorItemId = $tile.data('anchor-item-id');
        }
        var position = $tile.closest('.shop-the-look__products').find('.shop-the-look__product-tile').index($tile) + 1 + '';
        var selectedId = $tile.data('id-selected') || '';
        var lookId = $tile.data('look-id') || 'look_1';

        shopTheLookDataLayer.pushStlCarouselClickedEvent(
            position,
            selectedId,
            lookId,
            anchorItemId,
            window.location.href
        );
    });


    // Mobile nested carousels
    var nestedCarousels = document.querySelectorAll('.shop-the-look__products-carousel.embla-nested');
    if (nestedCarousels.length > 0) {
        nestedCarousels.forEach(function (node) {
            var nestedOptions = {
                loop: false,
                align: 'start',
                dragFree: true,
                axis: 'x',
                watchFocus: false
            };
            // eslint-disable-next-line new-cap
            var nestedEmbla = EmblaCarousel.default ? EmblaCarousel.default(node, nestedOptions) : EmblaCarousel(node, nestedOptions);
            activeInstances.push(nestedEmbla);

            // Prevent outer carousel from dragging when touching the nested carousel
            var stopPropagation = function (e) {
                e.stopPropagation();
            };
            node.addEventListener('touchstart', stopPropagation, { passive: true });
            node.addEventListener('touchmove', stopPropagation, { passive: true });
            node.addEventListener('mousedown', stopPropagation, { passive: true });
            node.addEventListener('mousemove', stopPropagation, { passive: true });
            node.addEventListener('pointerdown', stopPropagation, { passive: true });
            node.addEventListener('pointermove', stopPropagation, { passive: true });
        });
    }
}

function domUpdates() {
    var productDetailsSection = $('.product-details-section');
    var shopTheLook = $('.shop-the-look');
    if (productDetailsSection.length > 0 && shopTheLook.length > 0) {
        // add class to product details section to remove border bottom for G4 site
        productDetailsSection.addClass('above-shop-the-look');
    }

    var tileBody = $('.shop-the-look .tile-body');
    tileBody
        .on('focus', '.pdp-link .quickview, .pdp-link .link, .shop-the-look__quickview', function () {
            $(this).closest('.product-tile').addClass('is-focused');
        })
        .on('blur', '.pdp-link .quickview, .pdp-link .link, .shop-the-look__quickview', function () {
            $(this).closest('.is-focused').removeClass('is-focused');
        });

    function updateSTLNameTabindex() {
        var $stlLinks = $('.shop-the-look .pdp-link .quickview');
        var isMobile = window.innerWidth < 992;
        $stlLinks.attr('tabindex', isMobile ? '0' : '-1');
    }
    updateSTLNameTabindex();
    var resizeTimeout;
    $(window).off('resize.stlTabindex').on('resize.stlTabindex', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            updateSTLNameTabindex();
        }, 400);
    });
}

/**
 * Handle re-initialization on successful color update
 * @param {string} url - The URL to fetch the updated Shop the Look content from
 */
function updateShopTheLook(url) {
    if (!url) return;
    var $shopTheLookContainer = $('.shop-the-look-wrapper');
    if ($shopTheLookContainer.data('last-url') === url) {
        return;
    }
    $shopTheLookContainer.data('last-url', url);

    $.ajax({
        url: url,
        method: 'GET',
        success: function (data) {
            $shopTheLookContainer.empty().html(data);
            // domUpdates() sets the viewport-based baseline tabindex (e.g. the
            // mobile-only quickview link) before initCarousel()'s roving tabindex
            // layers slide-visibility on top of it — reversing this order would let
            // the baseline reset re-enable tabbing on off-screen slides.
            domUpdates();
            initCarousel(true);
            addGalleryCtas($shopTheLookContainer);
            // Optional: Re-trigger lazy loading if used
            if (typeof $.fn.unveil === 'function') {
                $shopTheLookContainer.find('.lazy').unveil();
            }
        },
        error: function () {
            // Silently fail or hide container
            $shopTheLookContainer.empty();
            removeGalleryCtas();
        }
    });
}

module.exports = {
    init: initCarousel,
    update: updateShopTheLook
};
